import { handleResponse } from "utils/utils";
import { authService } from "services";

export const loginAttemptsService = {
	getAll,
};

function getAll(options, signal) {
	const requestOptions = {
		method: "GET",
		headers: {
			Authorization: `Bearer ${authService.token.access_token}`,
		},
	};

	if (signal) {
		requestOptions.signal = signal;
	}

	let query = "?sort=-created";

	if (options) {
		const { q, from, to, failed_login_attempt, page, page_size } = options;

		if (q) query += "&q=" + q;
		if (from) query += "&from=" + from;
		if (to) query += "&to=" + to;
		if (failed_login_attempt) query += "&failed_login_attempt=true";
		if (page !== undefined) query += "&page=" + page;
		if (page_size !== undefined) query += "&page_size=" + page_size;
	}

	return fetch(`${global.BASE_API}login-attempts${query}`, requestOptions).then(
		handleResponse
	);
}
